import { render, staticRenderFns } from "./ChannelOperator.vue?vue&type=template&id=0406fb32&scoped=true"
import script from "./ChannelOperator.vue?vue&type=script&lang=js"
export * from "./ChannelOperator.vue?vue&type=script&lang=js"
import style0 from "./ChannelOperator.vue?vue&type=style&index=0&id=0406fb32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406fb32",
  null
  
)

export default component.exports